import React from 'react';
import { FDPaper, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

export const PM2JourneyMemberQuestionsChecklistLayout = () => {
  return (
    <FDStack direction="column" spacing={8} paddingY={4}>
      <FDStack direction="column" spacing={4}>
        <MetaControlField attr="stepper" />
        <MetaControlField attr="title" />
      </FDStack>
      <FDPaper padding={3}>
        <MetaControlField attr="resolvedQuestions" />
      </FDPaper>
    </FDStack>
  );
};
